var PubSub = require("underpub-js");
var Wallop = require("wallop");

var expandableSlideshow = function(options) {
  this.options = {
    $el: false,
  };

  $.extend(true, this.options, options);
};

expandableSlideshow.prototype.init = function() {
  var self = this;

  var imagesSlider = this.options.$el.find(".images-slider")[0]; // wallop takes a plain JS element, so use [0]
  var imagesWallop = new Wallop(imagesSlider);

  this.modalId = this.options.$el.data("modalId");
  this.currentSlideNum = 1;
  this.slideCount = this.options.$el.data("slideCount");

  this.$arrowPrev = this.options.$el.find(".arrow-left");
  this.$arrowNext = this.options.$el.find(".arrow-right");

  this.$arrowPrev.on("click", () => imagesWallop.previous());
  this.$arrowNext.on("click", () => imagesWallop.next());

  var slideChange = function(event) {
    var activeSlideNum = event.detail.currentItemIndex;
    self.currentSlideNum = activeSlideNum + 1;
  };

  imagesWallop.on("change", slideChange);

  if (this.slideCount > 1) {
    window.setInterval(function() {
      imagesWallop.next();
    }, 8000);
  }

  // expand button
  this.options.$el.find(".expand-bar").on("click", function() {
    PubSub.publish("modalImageGallery:openToImage", [
      self.modalId,
      self.currentSlideNum,
    ]);
  });
};

module.exports = expandableSlideshow;
